





































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import _ from "@/boot/lodash";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IState } from "@/store";
import { ILanguage } from "@/models/constants";
import { ITranslation } from "@/models/translations";

@Component({
  components: {
    "notification-content": () =>
      import("@/components/app/global/templates/contentForm.vue")
  },
  computed: {
    ...mapState({
      languages: (state: IState) => state.brand.languages
    })
  }
})
export default class TermsAndConditionsTranslationModal extends Mixins(
  HasValidation
) {
  // Map state

  public languages!: ILanguage[];

  // Props

  @Prop({ default: null })
  public translation!: any | null;

  @Prop({ required: true })
  public languageId!: ILanguage["id"];

  @Prop({ required: true })
  public termsAndConditionId!: ITranslation["id"];

  public isProcessing = false;

  public form = {
    name: "",
    language_id: this.languageId,
    terms: this.translation?.terms ?? ""
  };
  public initialForm;

  public get isFormChanged(): boolean {
    return !this.$_.isEqual(this.form, this.initialForm);
  }

  public created() {
    this.initialForm = _.cloneDeep(this.form);
  }

  public async validateBeforeSubmit() {
    if (!this.canSave) return;

    this.isProcessing = true;

    try {
      await this.saveTranslation();

      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.translations.successfully_updated")
      });

      this.$emit("close");
      this.$emit("success");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public saveTranslation() {
    return this.$store.dispatch(
      `data/${DataModules.TERMS_AND_CONDITIONS}/saveTranslation`,
      {
        id: this.termsAndConditionId,
        data: {
          translations: [this.form]
        }
      }
    );
  }

  public get canSave() {
    return this.$userCan("create_terms_and_conditions");
  }

  public get exists() {
    return !_.isEmpty(this.translation);
  }
}
